package com.trevorwiebe.timesheet.admin.equipment.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.Equipment
import com.trevorwiebe.timesheet.mileage.domain.model.EquipmentType

sealed class EquipmentEvent {
    data object OnAddEquipmentClick : EquipmentEvent()
    data class OnEditEquipmentClick(val equipment: Equipment) : EquipmentEvent()
    data object OnDismissDialog : EquipmentEvent()
    data class OnSaveEquipment(
        val unitNumber: String,
        val type: EquipmentType,
        val active: Boolean,
        val serviceInterval: Long,
        val serviceWarningMiles: Long
    ) : EquipmentEvent()
    data object OnDeleteEquipment : EquipmentEvent()
    data object OnRestoreEquipment : EquipmentEvent()
    data class OnMakeActiveAfterRestore(val makeActive: Boolean) : EquipmentEvent()
    data class OnFilterToggled(val filter: EquipmentFilter) : EquipmentEvent()
    data class OnSortChanged(val sort: EquipmentSort?) : EquipmentEvent()
}
